import type { TaskFormData } from "@/components/task-confirmation-modal";

export function generateCronExpression(data: TaskFormData): string | null {
	if (data.schedule === "daily") {
		return `${data.timeMinute ?? 0} ${data.timeHour ?? 9} * * *`;
	}
	if (data.schedule === "weekly") {
		const days = (data.daysOfWeek ?? []).sort().join(",");
		return `${data.timeMinute ?? 0} ${data.timeHour ?? 9} * * ${days}`;
	}
	if (data.schedule === "monthly") {
		return `${data.timeMinute ?? 0} ${data.timeHour ?? 9} ${data.dayOfMonth ?? 1} * *`;
	}
	return null;
}
